import { Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { ILayoutContent } from "@models/entity-models";

@Kbo(CToken.LayoutContent)
export class LayoutContent extends UiObject implements ILayoutContent {

    constructor(kom: KbObjectManager) {
        super(kom);
    }    

    public idContent: string;
    public nameInLayout: string;
    public contentType: string;
    public $foundInCurrentLayout: boolean;

    private _children: UiObject[];
    @Enumerable()
    public get children(): UiObject[] {
        if (!this._children) this._children = [];
        return this._children;
    }
    public set children(val) {
        this._children = val;
    }

    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return this.filterChildren<T>(tokens,
            this.children
        );
    }

    public allowedChildren(rootType: CToken): CToken[] {
        if (rootType == CToken.Configurator && this.contentType == CToken.Container.key) {
            return this.containerChildren(rootType);
        } else {
            return [];
        }
    }
}
